import { createRoute } from '@tanstack/react-router';
import { adminParentRoute } from 'pages/admin/adminParentRoute';
import { pageResetMiddleWare, zodOptionalId, zodPage } from 'routes/routeUtils';
import { z } from 'zod';

export const adminExpiredProductsRequestsRoute = createRoute({
  getParentRoute: () => adminParentRoute,
  path: '/expired_products_requests',
  validateSearch: z.object({
    page: zodPage,
    query: z.string().optional(),
    tab: z
      .enum([
        'ongoing',
        'awaiting_signing',
        'signed_by_pharmacy',
        'validated_by_lab',
        'archived_by_pharmacy',
        'refused_by_lab',
        'draft',
        'deleted',
        'all',
      ])
      .default('ongoing'),
    pharmacyId: zodOptionalId,
  }),
  search: { middlewares: [pageResetMiddleWare] },
}).lazy(() =>
  import(
    'pages/admin/ExpiredProductsRequests/AdminExpiredProductsRequestsPage/AdminExpiredProductsRequestsPage'
  ).then((d) => d.Route)
);
